import { Reveal } from "@/components/Reveal";
import QuoteForm from "@/components/QuoteForm";
import { Phone, WhatsappLogo, Clock } from "@phosphor-icons/react";
import { CONTACT } from "@/data/site";
import { telUrl, whatsappUrl } from "@/lib/contact";

export default function QuoteSection() {
  return (
    <section id="orcamento" className="bg-brand-obsidian py-24 md:py-32" data-testid="quote-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Solicitar Guincho</p>
            <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
              Peça seu atendimento agora
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">
              Preencha os dados abaixo e envie direto para o nosso WhatsApp. Respondemos rápido, 24 horas
              por dia. Se preferir, ligue ou fale conosco imediatamente.
            </p>

            <div className="mt-10 space-y-4">
              <a href={telUrl()} data-testid="quote-phone" className="flex items-center gap-4 rounded-sm border border-white/10 bg-brand-coal p-5 transition-colors duration-300 hover:border-brand-red">
                <Phone weight="fill" className="h-6 w-6 text-brand-red" />
                <div>
                  <p className="text-xs uppercase tracking-wide text-white/40">Telefone</p>
                  <p className="font-heading text-lg text-white">{CONTACT.phoneDisplay}</p>
                </div>
              </a>
              <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" data-testid="quote-wa-link" className="flex items-center gap-4 rounded-sm border border-white/10 bg-brand-coal p-5 transition-colors duration-300 hover:border-brand-red">
                <WhatsappLogo weight="fill" className="h-6 w-6 text-brand-red" />
                <div>
                  <p className="text-xs uppercase tracking-wide text-white/40">WhatsApp</p>
                  <p className="font-heading text-lg text-white">{CONTACT.whatsappDisplay}</p>
                </div>
              </a>
              <div className="flex items-center gap-4 rounded-sm border border-white/10 bg-brand-coal p-5">
                <Clock weight="fill" className="h-6 w-6 text-brand-red" />
                <div>
                  <p className="text-xs uppercase tracking-wide text-white/40">Horário</p>
                  <p className="font-heading text-lg text-white">Aberto 24 horas, todos os dias</p>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="rounded-sm border border-white/10 bg-brand-coal p-6 md:p-8">
              <QuoteForm />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
